import {
  FETCH_CONDITIONS_SUCCESS,
  RESET_CONDITIONS_SUCCESS,
} from '../../../search/constants'
import openPopup from '../../../PopupConstructor/actions/popupActions'
import {GLOBAL_ERROR_POPUP} from '../../../PopupConstructor/constants'
import fetchConditionsData from 'js/apiCalls/conditions';

const fetchConditionsSuccess = payload => ({
  type: FETCH_CONDITIONS_SUCCESS,
  payload,
})

export const resetConditions = () => ({
  type: RESET_CONDITIONS_SUCCESS,
})

const fetchConditions = async (params, dispatch) => {
  try {
    const { data } = await fetchConditionsData(params)
    dispatch(fetchConditionsSuccess(data))
  } catch (e) {
    const data = e?.response?.data
    if (data.message) {
      dispatch(openPopup(GLOBAL_ERROR_POPUP, data))
    }
  }
}

export default (params) => (dispatch) => fetchConditions(params, dispatch)
